import {request} from "../request/request";

const message = {
  postOne: (data) => request.create('/message', data, true),
};

export {message};